import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {DOMAIN} from './constants';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${DOMAIN}/FETCH`,
    childId => ({childId}),
    (childId, child, napsSummary) => ({childId, child, napsSummary}),
);

export const {
    action: emberFetch,
    success: emberFetchSuccess,
    failed: emberFetchFailed,
} = createAction(
    `${DOMAIN}/EMBER_FETCH`,
    childId => ({childId}),
    (childId, child, institution, group, napsSummary) => ({childId, child, institution, group, napsSummary}),
);

export const {
    action: fetchBasicChildInfo,
    success: fetchBasicChildInfoSuccess,
    failed: fetchBasicChildInfoFailed,
} = createAction(
    `${DOMAIN}/FETCH_BASIC_CHILD_INFO`,
    childId => ({childId}),
    child => ({child}),
);

export const {
    action: updateBasicChildInfo,
    success: updateBasicChildInfoSuccess,
    failed: updateBasicChildInfoFailed,
} = createAction(`${DOMAIN}/UPDATE_BASIC_CHILD_INFO`, child => ({child}));

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(
    `${DOMAIN}/FETCH_ALL`,
    data => data,
    children => ({children}),
);

export const {
    action: updateKeyWorkers,
    success: updateKeyWorkersSuccess,
    failed: updateKeyWorkersFailed,
} = createAction(
    `${DOMAIN}/UPDATE_KEY_WORKERS`,
    (childId, primaryEmployeeId, secondaryEmployeeId) => ({childId, primaryEmployeeId, secondaryEmployeeId}),
    (childId, keyWorkers) => ({childId, keyWorkers}),
);

export const {
    action: createChild,
    success: createChildSuccess,
    failed: createChildFailed,
} = createAction(`${DOMAIN}/CREATE_CHILD`, (institutionId, name, startDate, birthday, groupId, gender) => ({
    institutionId,
    name,
    startDate,
    birthday,
    groupId,
    gender,
}));

export const {
    action: fetchChildren,
    success: fetchChildrenSuccess,
    failed: fetchChildrenFailed,
} = createAction(
    `${DOMAIN}/FETCH_CHILDREN`,
    (
        institutionId,
        embedRelations,
        includeFuture,
        includePast,
        groupIds,
        tagIds,
        alwaysShowPickup,
        overrideAll = false,
    ) => ({
        institutionId,
        embedRelations,
        includeFuture,
        includePast,
        groupIds,
        tagIds,
        alwaysShowPickup,
        overrideAll,
    }),
    ({children, overrideAll}) => ({children, overrideAll}),
);

export const {
    action: updateGroup,
    success: updateGroupSuccess,
    failed: updateGroupFailed,
} = createAction(`${DOMAIN}/UPDATE_GROUP`, (childId, groupId) => ({childId, groupId}));

export const {
    action: removeTag,
    success: removeTagSuccess,
    failed: removeTagFailed,
} = createAction(
    `${DOMAIN}/REMOVE_TAG`,
    (childId, tagId) => ({childId, tagId}),
    (childId, tagId) => ({childId, tagId}),
);

export const {
    action: addTag,
    success: addTagSuccess,
    failed: addTagFailed,
} = createAction(
    `${DOMAIN}/ADD_TAG`,
    (childId, tagId) => ({childId, tagId}),
    (childId, tagId) => ({childId, tagId}),
);

export const {
    action: updateTags,
    success: updateTagsSuccess,
    failed: updateTagsFailed,
} = createAction(
    `${DOMAIN}/UPDATE_TAGS`,
    (childId, enableTagIds, disableTagIds) => ({childId, enableTagIds, disableTagIds}),
    (childId, enableTagIds, disableTagIds) => ({childId, enableTagIds, disableTagIds}),
);

export const {
    action: checkIn,
    success: checkInSuccess,
    failed: checkInFailed,
} = createAction(
    `${DOMAIN}/CHECK_IN`,
    (childId, groupId) => ({childId, groupId}),
    (childId, checkinTime) => ({childId, checkinTime}),
);

export const {
    action: checkOut,
    success: checkOutSuccess,
    failed: checkOutFailed,
} = createAction(
    `${DOMAIN}/CHECK_OUT`,
    childId => ({childId}),
    childId => ({childId}),
);

export const {
    action: fetchKikuChild,
    success: fetchKikuChildSuccess,
    failed: fetchKikuChildFailed,
} = createAction(
    `${DOMAIN}/FETCH_KIKU_CHILD`,
    childId => ({childId}),
    (childId, kikuChild) => ({childId, kikuChild}),
);

export const {
    action: updateKikuChild,
    success: updateKikuChildSuccess,
    failed: updateKikuChildFailed,
} = createAction(
    `${DOMAIN}/UPDATE_KIKU_CHILD`,
    (childId, kikuChild) => ({childId, kikuChild}),
    (childId, kikuChild) => ({childId, kikuChild}),
);

export const {success: fetchAutoGeneratedChildIdSuccess} = createAction(
    `${DOMAIN}/FETCH_AUTO_GENERATED_CHILD_ID`,
    childId => ({childId}),
    (childId, id) => ({childId, id}),
);

export const {success: updateAutoGeneratedChildIdSuccess} = createAction(
    `${DOMAIN}/UPDATE_AUTO_GENERATED_CHILD_ID`,
    (childId, id) => ({childId, id}),
    (childId, id) => ({childId, id}),
);
